import { rem } from '@visiba/std';
import { FlexibleTextModel } from '@services/flexible_component/mod';
import { Text } from '@visiba-cortex/react-ui-std';
import styled from 'styled-components';
import { FONT_VARIANT } from '../../constants';

interface Props {
	component: FlexibleTextModel;
}

const domCastingMap = new Map<FONT_VARIANT, 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span'>([
	[FONT_VARIANT.SMALL_BODY, 'p'],
	[FONT_VARIANT.BODY, 'p'],
	[FONT_VARIANT.LARGE_BODY, 'p'],
	[FONT_VARIANT.SMALL_TITLE, 'h3'],
	[FONT_VARIANT.TITLE, 'h2'],
]);

const fontVariantMap = new Map<string, FONT_VARIANT>([
	['SmallBody', FONT_VARIANT.SMALL_BODY],
	['Body', FONT_VARIANT.BODY],
	['LargeBody', FONT_VARIANT.LARGE_BODY],
	['SmallTitle', FONT_VARIANT.SMALL_TITLE],
	['Title', FONT_VARIANT.TITLE],
]);

const fontWeightMap = new Map<string, string>([
	['Regular', '400'],
	['Semibold', '600'],
	['Bold', '700'],
]);

const elements = {
	container: styled.div`
		margin: ${rem(8)} 0;
	`,
};

export function FlexibleText({ component }: Props): JSX.Element {
	const fontVariant = fontVariantMap.get(component.size) ?? FONT_VARIANT.BODY;
	const domAs = domCastingMap.get(fontVariant) ?? 'span';

	return (
		<elements.container>
			<Text as={domAs} data-testid='FlexibleText' font={fontVariant} fontWeight={fontWeightMap.get(component.weight)}>
				{component.value}
			</Text>
		</elements.container>
	);
}
